/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GondolaMappedCountry } from './GondolaMappedCountry';
import {
    GondolaMappedCountryFromJSON,
    GondolaMappedCountryFromJSONTyped,
    GondolaMappedCountryToJSON,
    GondolaMappedCountryToJSONTyped,
} from './GondolaMappedCountry';

/**
 * 
 * @export
 * @interface GondolaMappedTotalCountriesVisited
 */
export interface GondolaMappedTotalCountriesVisited {
    /**
     * 
     * @type {Array<GondolaMappedCountry>}
     * @memberof GondolaMappedTotalCountriesVisited
     */
    items: Array<GondolaMappedCountry>;
}

/**
 * Check if a given object implements the GondolaMappedTotalCountriesVisited interface.
 */
export function instanceOfGondolaMappedTotalCountriesVisited(value: object): value is GondolaMappedTotalCountriesVisited {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GondolaMappedTotalCountriesVisitedFromJSON(json: any): GondolaMappedTotalCountriesVisited {
    return GondolaMappedTotalCountriesVisitedFromJSONTyped(json, false);
}

export function GondolaMappedTotalCountriesVisitedFromJSONTyped(json: any, ignoreDiscriminator: boolean): GondolaMappedTotalCountriesVisited {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GondolaMappedCountryFromJSON)),
    };
}

export function GondolaMappedTotalCountriesVisitedToJSON(json: any): GondolaMappedTotalCountriesVisited {
    return GondolaMappedTotalCountriesVisitedToJSONTyped(json, false);
}

export function GondolaMappedTotalCountriesVisitedToJSONTyped(value?: GondolaMappedTotalCountriesVisited | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GondolaMappedCountryToJSON)),
    };
}

